import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import {
  assertIsASelectItem,
  assertIsNumberAndIsGreaterThanZero,
  type ISelectItem,
} from '~/types/models'

export enum OpportunityMSServicesStatusIds {
  BID_NEEDED = 1,
  RFQ_SENT = 2,
  BID_RCVD = 3,
  BID_ACCEPTED = 4,
  BID_REJECTED = 5,
  READY_FOR_CONTRACT = 6,
  CLOSED = 7,
  CLOSED_WON = 8,
  REOPENED = 9,
  NOT_SET = 11,
}

export function isAnyOpenOpportunityMSServiceStatus(status: ISelectItem) {
  assertIsASelectItem(isAnyOpenOpportunityMSServiceStatus.name, status)
  assertIsNumberAndIsGreaterThanZero(status.id)
  return [
    OpportunityMSServicesStatusIds.BID_NEEDED,
    OpportunityMSServicesStatusIds.RFQ_SENT,
    OpportunityMSServicesStatusIds.BID_RCVD,
    OpportunityMSServicesStatusIds.BID_ACCEPTED,
    OpportunityMSServicesStatusIds.BID_REJECTED,
    OpportunityMSServicesStatusIds.READY_FOR_CONTRACT,
    OpportunityMSServicesStatusIds.REOPENED,
  ].includes(status.id)
}

export function getOpportunityMSServicesStatii(): ISelectItem[] {
  return [
    { id: OpportunityMSServicesStatusIds.BID_NEEDED, label: 'Bid Needed' },
    { id: OpportunityMSServicesStatusIds.RFQ_SENT, label: 'RFQ Sent' },
    { id: OpportunityMSServicesStatusIds.BID_RCVD, label: 'Bid Rcvd' },
    { id: OpportunityMSServicesStatusIds.BID_ACCEPTED, label: 'Bid Accepted' },
    { id: OpportunityMSServicesStatusIds.BID_REJECTED, label: 'Bid Rejected' },
    {
      id: OpportunityMSServicesStatusIds.READY_FOR_CONTRACT,
      label: 'Ready for Contract',
      disabled: true,
    },
    {
      id: OpportunityMSServicesStatusIds.CLOSED,
      label: 'Closed',
      disabled: true,
    },
    {
      id: OpportunityMSServicesStatusIds.CLOSED_WON,
      label: 'CLOSED WON',
      disabled: true,
    },
    {
      id: OpportunityMSServicesStatusIds.REOPENED,
      label: 'Reopened',
      disabled: true,
    },
    {
      id: OpportunityMSServicesStatusIds.NOT_SET,
      label: 'Not Set',
      disabled: true,
    },
  ]
}

export const getOpportunityMSServiceStatusByLabel = getItemByLabelFactory(
  getOpportunityMSServicesStatii
)
export const getOpportunityMSServiceStatusById = getItemByIdFactory(
  getOpportunityMSServicesStatii
)
